import YouTube from "react-youtube";
import { Box, Typography } from "@mui/material";

const YoutubePlayer = ({ videoUrl }) => {
  // Funzione per estrarre l'ID del video dall'URL
  const extractVideoId = (url) => {
    if (!url) return null;
    const regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const videoId = extractVideoId(videoUrl);

  const opts = {
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 0, // Auto-play il video quando viene mostrato
      rel: 0,
      modestbranding: 1,
      controls: 1,
      disablekb: 0,
      fs: 1,
      iv_load_policy: 3,
      showinfo: 0,
      playsinline: 1,
    },
  };

  if (!videoId) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography color="error">URL di YouTube non valido.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingBottom: "56.25%", // 16:9
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "#000",
        my: 3,
        boxShadow: 3,
      }}
    >
      <YouTube
        videoId={videoId}
        opts={opts}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  );
};

export default YoutubePlayer;
